<template>
  <div style="color:white;" >
    <v-container fluid class="px-16 my-4">
      <FormulaTable />
    </v-container>
  </div>
</template>

<script>
import FormulaTable from '@/components/Admin/FormulaTable.vue';

export default {
  name: 'Home',
  components: {
    FormulaTable
  }
}
</script>

<style scoped>

</style>